import { Link } from 'react-router-dom';

import { HouseholdType, OpportunityView } from '@ndvr/customer-api';

import { formatDate } from 'utils';

import { OpportunityStatusBadge } from './OpportunityStatusBadge';

interface OpportunityCardProps {
    opportunity: OpportunityView;
    householdMap: Map<string, { name: string; type?: HouseholdType }>;
    onTitleClick?: (opportunity: OpportunityView) => void;
}

export const OpportunityCard = (props: OpportunityCardProps) => {
    const householdEntry = props.householdMap.get(props.opportunity.householdGUID);
    const householdType = householdEntry?.type;
    const householdName =
        householdEntry?.name || (householdType === HouseholdType.PROSPECT ? 'Unknown Prospect' : 'Unknown Household');

    return (
        <div className="space-y-2">
            <div
                className="cursor-pointer text-sm font-medium hover:underline"
                title={props.opportunity.name}
                onMouseDown={(e) => {
                    e.stopPropagation();
                    props.onTitleClick?.(props.opportunity);
                }}
            >
                <div className="flex min-w-0 items-center gap-2">
                    <span className="truncate">{props.opportunity.name || 'Untitled Opportunity'}</span>
                </div>
            </div>

            <div className="text-xs">
                <Link
                    to={`/${householdType === HouseholdType.PROSPECT ? 'prospect' : 'household'}/${props.opportunity.householdGUID}`}
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    {householdName}
                </Link>
            </div>

            {props.opportunity.description && (
                <div className="text-muted-foreground line-clamp-2 text-xs">{props.opportunity.description}</div>
            )}

            {props.opportunity.value && (
                <div className="text-muted-foreground text-xs">
                    Value: ${Number(props.opportunity.value).toLocaleString('en-US', { minimumFractionDigits: 0 })}
                </div>
            )}

            <div className="text-muted-foreground text-xs">Created: {formatDate(props.opportunity.createdAt)}</div>

            <div className="flex items-center gap-1">
                <OpportunityStatusBadge status={props.opportunity.status} />
            </div>
        </div>
    );
};
